import React from "react";
import { Palmtree } from "lucide-react";
import Logo from "./Logo";
import { company } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#071a2f] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-14">
        <div className="flex flex-col items-center text-center gap-6">
          <Logo />

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-2">
            {company.pills.map((p, i) => (
              <React.Fragment key={p}>
                <span className="font-cond uppercase tracking-[0.25em] text-[#7fd8f7] text-sm">
                  {p}
                </span>
                {i < company.pills.length - 1 && (
                  <span className="h-1.5 w-1.5 rounded-full bg-[#35c6f4]" />
                )}
              </React.Fragment>
            ))}
          </div>

          <p className="font-cond uppercase tracking-[0.2em] text-slate-300 text-sm">
            Your Property. Our Commitment.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-6 text-slate-300 text-sm mt-2">
            <a href={company.phoneHref} className="hover:text-[#35c6f4] transition-colors">
              {company.phone}
            </a>
            <span className="hidden sm:block h-4 w-px bg-white/20" />
            <a href={company.emailHref} className="hover:text-[#35c6f4] transition-colors break-all">
              {company.email}
            </a>
            <span className="hidden sm:block h-4 w-px bg-white/20" />
            <span>{company.location}</span>
          </div>
        </div>
      </div>

      {/* Water shimmer strip */}
      <div className="water-strip py-3">
        <div className="flex items-center justify-center gap-3 text-[#071a2f]">
          <Palmtree className="h-4 w-4" />
          <span className="font-cond uppercase tracking-[0.2em] text-xs md:text-sm font-semibold">
            {company.name} &copy; {new Date().getFullYear()}
          </span>
          <Palmtree className="h-4 w-4" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
